/*
 * Jozour — show the WELCOME10 popup only once per visitor.
 *
 * How it works: the Kalles theme only hides the newsletter popup when it finds the cookie
 * "kalles_newsletter<version>" = "shown". Kalles normally sets that cookie only when the
 * visitor closes the popup AND ticks "Don't show this again", so it kept coming back.
 * This script sets that same cookie (for 1 year) the moment the popup opens, so every
 * later page view skips it.
 */
(function () {
  if (window.Shopify && window.Shopify.designMode) return; // leave the theme editor alone

  var ONE_YEAR = 60 * 60 * 24 * 365;
  var done = false;

  function cookieName() {
    // Kalles cookie = "kalles_newsletter" + the popup "version" setting (currently 2)
    var el = document.getElementById('t4s-popup__newsletter');
    try {
      var v = JSON.parse(el.getAttribute('data-stt')).pp_version;
      if (v) return 'kalles_newsletter' + v;
    } catch (e) {}
    return 'kalles_newsletter2';
  }

  function markShown() {
    if (done) return;
    done = true;
    document.cookie = cookieName() + '=shown; Max-Age=' + ONE_YEAR + '; Path=/; SameSite=Lax';
    observer.disconnect();
  }

  // The popup is loaded by the theme a few seconds after the page, so watch for it opening.
  var observer = new MutationObserver(function () {
    if (document.querySelector('.t4s-newsletter_pp_wrapper')) markShown();
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  // In case the popup is already open by the time this runs
  if (document.querySelector('.t4s-newsletter_pp_wrapper')) markShown();
})();
